import { useNavigate } from "react-router-dom";
import { useState } from "react";
import Explore from "../Explore";
import { getUser, removeUser } from "../utils/auth";
import { clearPenStorage } from "../utils/penStorage";

export default function ExplorePage() {
  const navigate        = useNavigate();
  const [user, setUser] = useState(getUser);

  const handleLogout = () => {
    removeUser();
    setUser(null);
    navigate('/');
  };

  const handleNewPen = () => {
    clearPenStorage();
    navigate('/editor');
  };

 return (
    <Explore
      user={user}
      onLogout={handleLogout}
      onGoHome={() => navigate('/')}
      onLogin={() => navigate('/login')}
      onNewPen={handleNewPen}
      onEditor={() => navigate('/editor')}
      onBlog={() => navigate('/blog')}
      onExplore={() => navigate('/explore')}
      onViewPens={() => navigate('/editor?pens=true')}
      onSettings={() => navigate('/editor?settings=true')}
      onOpenPen={(pen) => {
        sessionStorage.setItem('wsncode_shared_pen', JSON.stringify(pen));
        navigate('/shared');
      }}
    />
  );
}